export default {
    GBP: 'en-GB',
    USD: 'en-US',
    CAD: 'en-CA',
    AUD: 'en-AU',
    DKK: 'da-DK',
    CHF: 'de-CH',
    SGD: 'en-SG',
    IDR: 'in-ID',
    JPY: 'ja-JP',
    MYR: 'ms-MY',
    TWD: 'zh-TW',
    THB: 'th-TH',
    VND: 'vi-VN',
    HKD: 'zh-HK',
};